import Vue from 'vue';
// eslint-disable-next-line
export const usersEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/users/usersEventBus.js